import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AgricultureIcon(props: IconProps) {
    return <Icon {...props} iconKey={"agriculture"}/>
}
